var _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDocument(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 48,
    viewBox: "0 0 49 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.0859 4L12.0859 4C11.0251 4 10.0077 4.42143 9.25751 5.17157C8.50736 5.92172 8.08594 6.93913 8.08594 8L8.08594 40C8.08594 41.0609 8.50736 42.0783 9.25751 42.8284C10.0077 43.5786 11.0251 44 12.0859 44H36.0859C37.1468 44 38.1642 43.5786 38.9144 42.8284C39.6645 42.0783 40.0859 41.0609 40.0859 40L40.0859 16L28.0859 4Z",
    fill: "#E6E5FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.0859 4V15C28.0859 15.5523 28.5337 16 29.0859 16L40.0859 16",
    fill: "#8E8CEE"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.0859 24C15.0859 23.4477 15.5337 23 16.0859 23L32.0859 23C32.6382 23 33.0859 23.4477 33.0859 24C33.0859 24.5523 32.6382 25 32.0859 25L16.0859 25C15.5337 25 15.0859 24.5523 15.0859 24Z",
    fill: "#8E8CEE"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.0859 30C15.0859 29.4477 15.5337 29 16.0859 29L32.0859 29C32.6382 29 33.0859 29.4477 33.0859 30C33.0859 30.5523 32.6382 31 32.0859 31L16.0859 31C15.5337 31 15.0859 30.5523 15.0859 30Z",
    fill: "#8E8CEE"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.0859 36C15.0859 35.4477 15.5337 35 16.0859 35H32.0859C32.6382 35 33.0859 35.4477 33.0859 36C33.0859 36.5523 32.6382 37 32.0859 37H16.0859C15.5337 37 15.0859 36.5523 15.0859 36Z",
    fill: "#8E8CEE"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.0859 16C15.0859 15.4477 15.5337 15 16.0859 15H20.0859C20.6382 15 21.0859 15.4477 21.0859 16C21.0859 16.5523 20.6382 17 20.0859 17H16.0859C15.5337 17 15.0859 16.5523 15.0859 16Z",
    fill: "#8E8CEE"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocument);
export default __webpack_public_path__ + "static/media/document.3fc001ad6c8c841c8884092d72bec635.svg";
export { ForwardRef as ReactComponent };